export const mainSpend = {
    title: "Dépense",
    loading: "Chargement de la dépense",
    cancel: {
        label: "perdre vos modifications",
        title: "Annulation",
        content: "Vous êtes sur le point d'annuler l'ensemble de vos modifications. Vous confirmez ?"
    },
    create: "La dépense {number} a bien été sauvegardée."
}